/*
* @Author: zhangzhitao
* @Date: 2019-06-03 16:51:09
* @Des:
 * @Last Modified by: zhangzhitao
 * @Last Modified time: 2019-07-03 13:35:03
*/

<template>
  <div class="m-widget-outer">
    <div class="m-tool-box">
      <div
        class="u-btn u-btn-up"
        @click="handleSetOrder('up')"
      >
        <i class="h-icon-arrow_up"></i>
      </div>
      <div
        class="u-btn u-btn-down"
        @click="handleSetOrder('down')"
      >
        <i class="h-icon-arrow_down"></i>
      </div>
      <div
        class="u-btn u-btn-remove"
        @click="handleRemove"
      >
        <i class="h-icon-close"></i>
      </div>
    </div>
    <div>
      <component :is="part.mode"></component>
    </div>
  </div>
</template>

<script>
export default {
  name: 'farend-container',

  props: {
    index: {
      type: Number,
      default: 0
    },
    part: {
      type: Object,
      default: null
    },
    farEndPartsLength: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
    }
  },

  components: {},

  computed: {},

  mounted () { },

  methods: {
    handleSetOrder (arrow) {
      if (this.index === 0 && arrow === 'up') {
        this.$message.warning(this.$t('management.home.widget_is_top'))
      } else if (this.index === this.farEndPartsLength - 1 && arrow === 'down') {
        this.$message.warning(this.$t('management.home.widget_is_bottom'))
      } else {
        this.$emit('order', arrow, this.part, this.index)
      }
    },
    handleRemove () {
      this.$emit('remove', this.index)
    }
  }
}

</script>

<style lang="less" scoped>
.m-widget-outer {
  position: relative;
  width: 100%;
  overflow: hidden;
  .m-tool-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 140px;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    opacity: 1;
    z-index: 999;
    .u-btn {
      margin: 10px;
      width: 40px;
      height: 40px;
      line-height: 48px;
      font-size: 24px;
      color: #fff;
      font-weight: bolder;
      text-align: center;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.5);
      cursor: pointer;
      &.u-btn-remove {
        position: absolute;
        width: 60px;
        height: 60px;
        right: -30px;
        bottom: -30px;
        i {
          display: block;
          position: absolute;
          left: 13px;
          top: 11px;
        }
      }
      &:hover {
        background: rgba(0, 0, 0, 0.8);
      }
    }
  }
  &:hover {
    .m-tool-box {
      opacity: 1;
    }
  }
}
</style>
